import { Spacing } from '../../../enums/spacing'
import { BadgeSize } from '../types/badgeSize'
import { BadgeType } from '../types/badgeType'

const isLg = (size: BadgeSize) => size === 'lg'

export const getSizeStyles = (type: BadgeType, size: BadgeSize, isLarge: boolean): string => {
  switch (type) {
    case 'dot':
      return `
        width: ${isLg(size) ? '12px' : '8px'};
        height: ${isLg(size) ? '12px' : '8px'};
      `
    case 'icon':
      return `
        width: ${isLg(size) ? '28px' : '20px'};
        height: ${isLg(size) ? '28px' : '20px'};
      `
    case 'default':
    default:
      return isLarge
        ? `
          height: ${isLg(size) ? '28px' : '20px'};
          min-width: ${isLg(size) ? '40px' : '32px'};
          padding: 0 ${isLg(size) ? Spacing.S8 : Spacing.S6};
        `
        : `
          height: ${isLg(size) ? '28px' : '20px'};
          min-width: ${isLg(size) ? '28px' : '20px'};
          padding: 0 ${isLg(size) ? Spacing.S6 : Spacing.S4};
        `
  }
}
